import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "@env/environment";
import { map } from "rxjs";
import {SSOChiffrerWSDTO} from "@shared-ay/sso/sso.model";

@Injectable({ providedIn: "root" })
export class SsoApiV2Service {
	private http = inject(HttpClient);

	getCryptedSsoId() {
		return this.http
			.get<SSOChiffrerWSDTO>(`${environment.apiEmotion()}/v2/sso/client/encoder-ssoid`)
			.pipe(map((res) => res.ssoId));
	}
}
